<app-base-modal
  [title]="advertisementStatisticsResourceType.name"
  [modalMaxHeight]="'90vh'"
  [showStateToggle]="loginAndRoles?.role !== 'ROLE_PROMOTION_SPECIALIST'"
>
  @if (isLoading) {
    <app-loader/>
  }
  @if (recordData) {
    <div class="advertisement-statistics">
     <div
       class="advertisement-statistics-buttons"
       app-advertisement-statistics-buttons
       [isEditModeActive]="isEditModeActive"
       [recordData]="recordData"
       [advertisementStatisticsDialogData]="advertisementStatisticsDialogData"
       [loginAndRoles]="loginAndRoles"
       (fetchAdvertisementInitialStatisticsData)="fetchAdvertisementInitialStatisticsData()"
     ></div>
      <app-advertisement-statistics-fields
        [isEditModeActive]="isEditModeActive"
        [recordData]="recordData"
        (updatedField)="updatedField($event)"
      />
    </div>
  }
</app-base-modal>
